/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProviderAvailability } from '../models/ProviderAvailability';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderAvailabilityPublicService {

    /**
     * @returns ProviderAvailability
     * @throws ApiError
     */
    public static providerAvailabilityPublicRetrieve({
        availabilityToken,
        endOn,
        legacy,
        startOn,
    }: {
        availabilityToken: string,
        /**
         * End date (inclusive) used to filter provider availability.
         */
        endOn?: string,
        /**
         * Use legacy provider availability logic.
         */
        legacy?: boolean,
        /**
         * Start date (inclusive) used to filter provider availability.
         */
        startOn?: string,
    }): CancelablePromise<ProviderAvailability> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-availability-public/{availability_token}/',
            path: {
                'availability_token': availabilityToken,
            },
            query: {
                'end_on': endOn,
                'legacy': legacy,
                'start_on': startOn,
            },
        });
    }

}
